import { makeStyles } from "@material-ui/core";
import { Colors } from "../../../utils";

const makeClasses = makeStyles((theme) => ({
  card: {
    background: Colors.rgb.light_gray,
    padding: "1.25rem",
    borderRadius: "0.625rem",
    width: "21rem",
    [theme.breakpoints.down("sm")]: {
      width: "15rem",
    },
  },
  cardName: {
    margin: 0,
    fontSize: "1.25rem",
    fontWeight: "bold",
    color: Colors.rgb.primary,
  },
  cardSubtitle: {
    margin: 0,
    fontSize: "1rem",
    fontWeight: "bold",
    color: Colors.rgb.contentText,
    marginBottom: "0.625rem",
    textAlign: "right",
    paddingRight: "0.625rem",
  },
  cardItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0.938rem 0.625rem",
    fontSize: "0.875rem",
    "& p": {
      margin: 0,
    },
  },
  cardItemOdd: {
    borderRadius: "0.625rem",
    background: Colors.rgb.white,
  },
  cardItemValue: {
    textAlign: "right",
  },
}));

export default makeClasses;
